import { render, staticRenderFns } from "./ConservationStatus.vue?vue&type=template&id=b6dfaa0c&"
import script from "./ConservationStatus.vue?vue&type=script&lang=js&"
export * from "./ConservationStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports